import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPrintSettingDataTableRowFormMeta {
    lineNumber: FormInputMeta;
    seqNumber: FormInputMeta;
    fieldType: FormInputMeta;
    value: FormInputMeta;

    schema: any;
}

const printSettingDataTableRowFormMeta = {} as IPrintSettingDataTableRowFormMeta;

printSettingDataTableRowFormMeta.lineNumber = {
    name: "lineNumber",
    type: "number",
    label: "Line Num.",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !"),
};

printSettingDataTableRowFormMeta.seqNumber = {
    name: "seqNumber",
    type: "number",
    label: "Seq. Num.",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !"),
};

printSettingDataTableRowFormMeta.fieldType = {
    name: "fieldType",
    type: "text",
    label: "Field Type",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

printSettingDataTableRowFormMeta.value = {
    name: "value",
    type: "textarea",
    label: "Valeur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};


printSettingDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(printSettingDataTableRowFormMeta));

export default printSettingDataTableRowFormMeta;